import React from 'react';
import { motion } from 'framer-motion';
const overshoot = [0.34, 1.56, 0.64, 1] as const;
function GoogleGIcon() {
  return <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true" className="shrink-0" data-id="element-230" data-mp="2y5oxh1mot1ks">
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" data-id="element-231" data-mp="2jg14qosknb8o" />
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" data-id="element-232" data-mp="2afukmk2dbd0j" />
      <path fill="#FBBC05" d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" data-id="element-233" data-mp="20kjdonx7ba3c" />
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" data-id="element-234" data-mp="3ux0tjafpn7xy" />
    </svg>;
}
export function GoogleReviewsBadge() {
  return <motion.a href="https://maps.app.goo.gl/N3f44sRH7xF6vkn96" target="_blank" rel="noopener noreferrer" aria-label="5.0 stars · Google Reviews" initial={{
    opacity: 0,
    y: 16,
    scale: 0.9
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.5,
    ease: overshoot,
    delay: 1.2
  }} className="absolute z-10 left-4 bottom-5 max-w-[calc(100%-32px)] lg:left-10 lg:bottom-10 lg:max-w-none cursor-pointer" data-id="element-235" data-mp="1zkq8x4qkh1ap">
      <motion.div animate={{
      y: [0, -8, 0]
    }} transition={{
      duration: 3,
      ease: 'easeInOut',
      repeat: Infinity
    }} className="flex items-center gap-[10px] max-w-full overflow-hidden bg-white rounded-[100px] px-[14px] py-[10px] lg:px-[18px] lg:py-3 border border-[rgba(90,69,121,0.1)] shadow-[0_8px_24px_rgba(0,0,0,0.12),0_2px_8px_rgba(90,69,121,0.15)] transition-all duration-200 ease-in-out hover:scale-[1.04] hover:shadow-[0_12px_32px_rgba(0,0,0,0.18),0_4px_12px_rgba(90,69,121,0.2)]" data-id="element-236" data-mp="1ppog9yx31h3d">
        <GoogleGIcon data-id="element-237" data-mp="23ph1w03vl12w" />
        <span className="shrink-0 text-[10px] lg:text-[11px] text-[#F59E0B] leading-none tracking-tight" data-id="element-238" data-mp="23r1wtqu3qm1a">
          ★★★★★
        </span>
        <span className="font-sans font-semibold text-[11px] lg:text-[12px] text-[#1A1A2E] leading-none whitespace-nowrap truncate" data-id="element-239" data-mp="27ozmeursba57">
          5.0 · Google Reviews
        </span>
      </motion.div>
    </motion.a>;
}